import { Controller } from 'stimulus'
import { get } from '@rails/request.js'

export default class extends Controller {
  static targets = ["imagesHiddenInput"]
  static values = {
    newContentUrl: String
  }

  changeRuleType(event) {
    get(event.target.dataset.editRuleUrl, {
      query: { rule_type: event.target.value },
      responseKind: 'turbo-stream'
    })
  }

  changeBlockType(event) {
    get(this.newContentUrlValue, {
      query: { block_type: event.target.value },
      responseKind: 'turbo-stream'
    })
  }

  selectQuoteImage(event) {
    event.preventDefault()
    get('/template/image_contents/new', {
      query: { quote_image_id: event.currentTarget.dataset.quoteImageId },
      responseKind: 'turbo-stream'
    })
  }
}
